export default "__VITE_ASSET__DuX9qDQZ__"